<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <g clip-path="url(#clip0_40_2263)">
            <path d="M15.5646 12.2424L13.3317 10.0095C12.5343 9.21209 11.1786 9.5311 10.8596 10.5677C10.6204 11.2855 9.82296 11.6842 9.10526 11.5247C7.51037 11.126 5.35726 9.0526 4.95854 7.37797C4.71931 6.66024 5.19778 5.86279 5.91548 5.62359C6.95216 5.30461 7.27114 3.94895 6.47369 3.15151L4.24084 0.918659C3.60288 0.360447 2.64595 0.360447 2.08774 0.918659L0.572591 2.43381C-0.942556 4.0287 0.73208 8.25516 4.48008 12.0032C8.22807 15.7511 12.4545 17.5056 14.0494 15.9106L15.5646 14.3955C16.1228 13.7575 16.1228 12.8006 15.5646 12.2424Z" fill="#212121"/>
        </g>
        <defs>
            <clipPath id="clip0_40_2263">
            <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
            </clipPath>
        </defs>
    </svg>
</template>